import { render, staticRenderFns } from "./RegisterLinksList.vue?vue&type=template&id=3746573b&scoped=true"
import script from "./RegisterLinksList.vue?vue&type=script&lang=js"
export * from "./RegisterLinksList.vue?vue&type=script&lang=js"
import style0 from "./RegisterLinksList.vue?vue&type=style&index=0&id=3746573b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3746573b",
  null
  
)

export default component.exports